// Mock data for NutrifyMe premium website

export const navigation = [
  { label: 'Services', href: '#services' },
  { label: 'Blogs', href: '/blog' },
  { label: 'Recipes', href: '/recipes' },
  { label: 'Success Stories', href: '#stories' },
  { label: 'Our Products', href: '#products' },
];

export const stats = [
  {
    title: 'Online + Clinic Support',
    desc: 'Flexible guidance whether you prefer face-to-face or online care',
    icon: 'Video',
  },
  {
    title: '10,000+ Global Clients',
    desc: 'From weight & hormonal issues to gut health and energy restoration',
    icon: 'Users',
  },
  {
    title: 'Evidence, Not Influencer-Based',
    desc: 'Every recommendation is backed by nutrition science — not social media trends',
    icon: 'BookOpen',
  },
  {
    title: 'Personalised, Not Template Plans',
    desc: 'Your plan evolves as your body responds',
    icon: 'Sparkles',
  },
];

export const steps = [
  {
    num: '01',
    title: 'Book a Free Consultation Call',
    desc: 'Schedule a 15-min discovery call. No commitments, just clarity on your goals.',
  },
  {
    num: '02',
    title: 'We assess your goals & challenges',
    desc: 'A deep-dive into lifestyle, medical history, cravings, sleep and stress patterns.',
  },
  {
    num: '03',
    title: 'Start your personalised program',
    desc: 'Receive a plan tailored to your body, culture, routine — with weekly follow-ups.',
  },
];

export const products = [
  {
    id: 'p1',
    name: 'NutrifyMe Pumpkin Seeds',
    price: 349,
    tag: 'Bestseller',
    image: 'https://static.wixstatic.com/media/c049c8_2fa9ddc1274c46f9a7d1d85fb87671f3~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/file.jpg',
  },
  {
    id: 'p2',
    name: 'NutrifyMe Sunflower Seeds',
    price: 329,
    tag: 'New',
    image: 'https://static.wixstatic.com/media/c049c8_cf36caf2b30e4e97aa4fd736ec99e9f6~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/file.jpg',
  },
  {
    id: 'p3',
    name: 'Metabolism Booster Blue Tea',
    price: 599,
    tag: 'Popular',
    image: 'https://static.wixstatic.com/media/c049c8_bceb862b8b494cd6a9a8faa4e5c22a9a~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/file.jpg',
  },
  {
    id: 'p4',
    name: 'Gut Reset Tea',
    price: 549,
    tag: '',
    image: 'https://static.wixstatic.com/media/c049c8_2484b5c5b397407ab7b4a6afa8ffc92d~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/file.jpg',
  },
  {
    id: 'p5',
    name: 'Menopause Wellness Tea',
    price: 649,
    tag: 'Women',
    image: 'https://static.wixstatic.com/media/c049c8_7ec45a1b9a68405a819dca8dcb0afb7a~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/file.jpg',
  },
];

export const diets = [
  { id: 'd1', name: 'Basic Diet', price: 800, image: 'https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'A balanced starter plan for anyone new to structured nutrition.' },
  { id: 'd2', name: 'Weight Loss Diet', price: 1500, image: 'https://images.unsplash.com/photo-1606858374191-c18040e98ad7?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Sustainable fat loss with metabolic-friendly Indian meals.' },
  { id: 'd3', name: 'Weight Gain Diet', price: 1500, image: 'https://images.unsplash.com/photo-1543352632-fea6d4f83e78?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Lean weight-gain with muscle-supportive macros.' },
  { id: 'd4', name: 'PCOD / PCOS Diet', price: 1800, image: 'https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Hormone-friendly foods to regulate cycles and reduce insulin resistance.' },
  { id: 'd5', name: 'Diabetic Management', price: 1600, image: 'https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg?auto=compress&cs=tinysrgb&w=800', desc: 'Low-GI, portion-controlled meals to stabilise blood sugar.' },
  { id: 'd6', name: 'Post Pregnancy Diet', price: 1700, image: 'https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Nourishing recovery meals for new mothers.' },
  { id: 'd7', name: 'Pre Pregnancy Diet', price: 1500, image: 'https://images.unsplash.com/photo-1571934811356-5cc061b6821f?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Fertility-supportive nutrition for couples planning a family.' },
  { id: 'd8', name: 'Maintenance Diet', price: 1000, image: 'https://images.unsplash.com/photo-1563822249366-3efb23b8e0c9?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Keep the results — a lifestyle-first maintenance program.' },
  { id: 'd9', name: 'Pre-Wedding Diet', price: 2200, image: 'https://images.pexels.com/photos/20002955/pexels-photo-20002955.jpeg?auto=compress&cs=tinysrgb&w=800', desc: 'Glow, tone and feel your best on the big day.' },
  { id: 'd10', name: 'Body Building Diet', price: 2000, image: 'https://images.pexels.com/photos/15319037/pexels-photo-15319037.jpeg?auto=compress&cs=tinysrgb&w=800', desc: 'High-protein performance plans for lifters and athletes.' },
  { id: 'd11', name: 'Hypertension Diet', price: 1400, image: 'https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'DASH-inspired sodium-controlled meal planning.' },
  { id: 'd12', name: 'Infertility Diet', price: 1800, image: 'https://images.unsplash.com/photo-1606858374191-c18040e98ad7?crop=entropy&cs=srgb&fm=jpg&w=800&q=80', desc: 'Reproductive-health focused nutrition therapy.' },
];

export const testimonials = [
  {
    name: 'Amruta Holikatti',
    image: 'https://static.wixstatic.com/media/c049c8_acfbc09d9aab476c8903001ed974e8a9~mv2.png/v1/fill/w_200,h_200,al_c,q_85/Amruta.png',
    text: 'I recently completed a 3-month diet plan with Dietitian Prachi through NutrifyMe, and my experience has been excellent. The plan helped me achieve a weight loss of 5 kg in 3 months. Beyond that, I gained valuable knowledge about healthy eating and sustainable habits.',
    rating: 5,
  },
  {
    name: 'Meena Kadakia',
    image: 'https://static.wixstatic.com/media/c049c8_ad38cb8f1146462c982bf59e728431ba~mv2.png/v1/fill/w_200,h_200,al_c,q_85/Meena.png',
    text: 'My experience with Prachi Ma\'am is great. She listens patiently and gives diet accordingly. Her diet not only helps reduce weight but improves medical issues also. I never feel cravings — chillas, smoothies, salads, millets, dosas — the variety is amazing.',
    rating: 5,
  },
  {
    name: 'Shruti Vadera',
    image: 'https://static.wixstatic.com/media/c049c8_0cd1055df42d4fb5a83ba7e979dabfe0~mv2.png/v1/fill/w_200,h_200,al_c,q_85/Shruti%20Vadera.png',
    text: 'My husband & I enrolled for a nutrition plan with Prachi. My husband saw a phenomenal fat loss within 3 months along with zero cravings, the same for me. The plans are easy to follow and catered using local ingredients. 10/10 recommended!',
    rating: 5,
  },
  {
    name: 'Rohit Sharma',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    text: 'As a working professional with erratic hours, I needed something that fits my life. Prachi understood that immediately. Down 8kg in 4 months, energy is back and my acidity is completely gone.',
    rating: 5,
  },
  {
    name: 'Kavya Rao',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    text: 'My PCOS is finally in control. Regular periods, less mood swings, and I actually enjoy the food. This isn\'t a diet — it\'s a whole lifestyle upgrade.',
    rating: 5,
  },
];

export const gallery = [
  'https://static.wixstatic.com/media/c049c8_0a9cf24db897424a8f2f83c941994c75~mv2.png/v1/fill/w_500,h_500,al_c,q_80/c049c8_0a9cf24db897424a8f2f83c941994c75~mv2.png',
  'https://static.wixstatic.com/media/c049c8_2157a4b4521e49fe9382ec46c2bf0c09~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/c049c8_2157a4b4521e49fe9382ec46c2bf0c09~mv2.jpeg',
  'https://static.wixstatic.com/media/c049c8_59e5367dfc144293a550415a0d5cdc69~mv2.jpg/v1/fill/w_500,h_500,al_c,q_80/c049c8_59e5367dfc144293a550415a0d5cdc69~mv2.jpg',
  'https://static.wixstatic.com/media/c049c8_ef5857f6f35e4106a5222dff0fb8eba0~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/c049c8_ef5857f6f35e4106a5222dff0fb8eba0~mv2.jpeg',
  'https://static.wixstatic.com/media/c049c8_ac9e46c0c61a401aa6ae688f9dc566b9~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/c049c8_ac9e46c0c61a401aa6ae688f9dc566b9~mv2.jpeg',
  'https://static.wixstatic.com/media/c049c8_891fbbba7a0349809ae2c8b8555a4f26~mv2.jpg/v1/fill/w_500,h_500,al_c,q_80/c049c8_891fbbba7a0349809ae2c8b8555a4f26~mv2.jpg',
  'https://static.wixstatic.com/media/c049c8_2933ae64d6a44978b569f175fab330ad~mv2.png/v1/fill/w_500,h_500,al_c,q_80/c049c8_2933ae64d6a44978b569f175fab330ad~mv2.png',
  'https://static.wixstatic.com/media/c049c8_1e85e48a1f7a4f5b9c2666388d7e9853~mv2.jpeg/v1/fill/w_500,h_500,al_c,q_80/c049c8_1e85e48a1f7a4f5b9c2666388d7e9853~mv2.jpeg',
];

export const blogs = [
  {
    title: '7-Day PCOS Reset: What to Eat and Skip',
    excerpt: 'A practical guide to reducing insulin resistance with everyday Indian foods.',
    tag: 'Hormones',
    image: 'https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?w=800&q=80',
    date: 'May 12, 2025',
  },
  {
    title: 'The Truth About Intermittent Fasting for Women',
    excerpt: 'Why the same fasting protocol men swear by can backfire for women over 30.',
    tag: 'Nutrition',
    image: 'https://images.unsplash.com/photo-1606858374191-c18040e98ad7?w=800&q=80',
    date: 'May 4, 2025',
  },
  {
    title: 'Gut Health 101: The Silent Weight Loss Blocker',
    excerpt: 'Bloating? Cravings? Fatigue? Your gut microbiome may be the missing piece.',
    tag: 'Gut Health',
    image: 'https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?w=800&q=80',
    date: 'Apr 28, 2025',
  },
];

export const recipes = [
  { name: 'Ragi Chocolate Smoothie', time: '5 min', cal: 220, image: 'https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?w=600&q=80' },
  { name: 'Millet Poha Bowl', time: '15 min', cal: 310, image: 'https://images.unsplash.com/photo-1606858374191-c18040e98ad7?w=600&q=80' },
  { name: 'Moong Chilla with Chutney', time: '20 min', cal: 280, image: 'https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?w=600&q=80' },
  { name: 'Overnight Oats & Chia', time: '5 min', cal: 340, image: 'https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg?auto=compress&w=600' },
];
